import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=06cfffba&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cfffba')) {
      api.createRecord('06cfffba', component.options)
    } else {
      api.reload('06cfffba', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=06cfffba&", function () {
      api.rerender('06cfffba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/product/Index.vue"
export default component.exports